import { Directive, ElementRef, HostListener, OnInit, Renderer2 } from '@angular/core';
import { Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Directive({
  selector: '[appTooltip]'
})
export class TooltipDirective implements OnInit {
  el: any;
  constructor(el: ElementRef, private renderer: Renderer2) {
    this.el = el;
  }

  @Input() tooltipText: BehaviorSubject<string> = new BehaviorSubject<string>('');
  @Input() tooltipContent: any;
  @Input() itemChanged: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  mouseEvent: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  @HostListener('mouseenter') onMouseEnter() {
    this.mouseEvent.next(true);

  }
  @HostListener('mouseleave') onMouseLeave() {
    this.mouseEvent.next(false);
  }

  ngOnInit() {
    this.renderer.setStyle(this.tooltipContent, 'position', 'relative');
    this.itemChanged.subscribe(itemChanged => {
      const tooltip = this.tooltipContent.querySelector('.tooltip-select');
      if (itemChanged === true && tooltip) {
        this.renderer.setStyle(tooltip, 'display', 'none');
      }
    });
    this.mouseEvent.subscribe(mouseEvent => {
      if (mouseEvent === true) {
        this.tooltipText.subscribe(tooltipText => {
          if (tooltipText === '') {
            return;
          }
          let tooltip = this.tooltipContent.querySelector('.tooltip-select');
          let tooltiptext = this.tooltipContent.querySelector('.tooltiptext');
          if (tooltip === null) {
            tooltip = document.createElement('div');
            this.renderer.appendChild(this.tooltipContent, tooltip);
            tooltip.classList.add('tooltip-select');
            tooltiptext = document.createElement('span');
            tooltiptext.classList.add('tooltiptext');
            tooltip.appendChild(tooltiptext);
            tooltiptext.innerHTML = tooltipText;
          } else {
            this.renderer.setProperty(tooltiptext, 'innerText', tooltipText);
            this.renderer.setStyle(tooltip, 'display', 'block');
          }
        });
      }
      if (mouseEvent === false) {
        const tooltip = this.tooltipContent.querySelector('.tooltip-select');
        if (tooltip) {
          this.renderer.setStyle(tooltip, 'display', 'none');
        }
      }
    });
  }
}
